export default {
    差价合约:'ETF 差价合约',
    把握全球:'交易全球100只热门ETF差价合约，涵盖：宽基股票ETF、债券/固收类ETF、区域/国家主题ETF、行业/主题ETF、红利ETF、杠杆/特殊ETF等。免基金账户、双向交易、杠杆加持！',
    即刻开户:'即刻开户',
    优势:'优势',
    差价合约是一种:'ETF 差价合约是一种灵活的金融工具，支持全球主流 ETF 的杠杆双向交易，适合希望捕捉市场波动、进行多样化配置的投资者。',
    品种丰富:'品种丰富',
    支持100:'支持100种热门ETF CFD交易',
    灵活交易:'灵活交易',
    支持买入:'支持买入/卖出，捕捉涨跌机会',
    无需持有:'无需持有',
    无需持有资产:'无需持有资产，轻松交易全球ETF',
    杠杆交易:'杠杆交易',
    杠杆配置:'5:1杠杆配置，提升资金使用效率',
    开设模拟账户:'开设模拟账户',
    开设真实账户:'开设真实账户',
    如何开始交易:'如何开始交易',
    注册账号:'注册账号',
    注册并登录:'注册并登录用户中心，完成身份认证',
    下载MT5交易平台:'下载MT5交易平台',
    开通真实交易账号:'开通真实交易账号。',
    开始交易:'开始交易',
    选择ETF:'选择ETF CFD产品',
    即刻交易:'即刻交易',
    差价合约相关问题:'ETF 差价合约相关问题',
    ETF是什么:'1. ETF是什么？',
    ETF全称是:'ETF全称是“交易型开放式指数基金”，简单说就是‌把一堆股票打包成一个套餐，放在股市里买卖‌。比如你想买科技股但不会选，买科技ETF就等于同时持有苹果、微软等一堆科技公司股票。',
    有什么区别:'2. ETF CFD 和传统 ETF 有什么区别？',
    是差价合约交易:'ETF CFD 是差价合约交易，不涉及实物资产交割，无需开户证券账户，也无需持有ETF份额；更适合短线、双向、杠杆交易策略。',
    购买ETF才能交易:'3. 是否需要实际购买ETF才能交易？',
    通过EBC提供的ETF:'不需要。通过EBC提供的ETF CFD产品，您无需持有ETF即可交易ETF价格波动，所有操作均在交易平台内完成。',
    交易会收取哪些费:'4. ETF CFD 交易会收取哪些费用？',
    您无需支付传统ETF的管理费:'您无需支付传统ETF的管理费与佣金。交易成本主要为点差和过夜持仓的融资费用，具体费用在平台上实时展示。',
    可以做空吗:'5. ETF CFD 可以做空吗？',
    与传统ETF只能做多不:'可以。与传统ETF只能做多不同，ETF CFD支持看空交易，适合震荡市或下跌行情下的策略部署。',
    适合新手交易者:'6. ETF CFD 适合新手交易者吗？',
    CFD产品具有杠杆属性:'CFD产品具有杠杆属性，适合有一定风险意识和交易经验的用户。我们建议新手通过模拟账户熟悉产品机制后再进行实盘交易。',
    市场报价:'市场报价',
    查看所有产品:'查看所有产品',
}